import React from 'react';
import { Button } from 'reactstrap';
import { useHistory, useLocation} from 'react-router-dom';
import './UpdateButton.scss';

//Presentational component to display the Update buttons when reviewing each wizard section.
//Pass in the nextRoute via props. 
function UpdateButton(props) {
  let history = useHistory();
  // let location = useLocation();
  const curURL = new URL(window.location.href);
  return(
    <Button className="aa-update-button float-end" color="secondary" outline aria-label="Update this section"
      onClick={() => {
        console.log("history: " + JSON.stringify(history));
        console.log("nextRoute: " + props.nextRoute);
        history.push({
          pathname: props.nextRoute,
          search: curURL.search
        });
          // history.push(props.nextRoute);
      }}
    >
      Update
    </Button>
  );
}

export default UpdateButton;

